import { DISCOUNT_FIELDS } from '~~/constants/commerceTools';
import { getDiscountCustomField } from '~~/helpers/discounts/cartDiscountFields';
import type { CartDiscountFieldsSource } from '~~/helpers/discounts/cartDiscountFields';

/**
 * How many pieces of the same product a volume discount needs, configured in
 * commercetools as the `quantityMin` custom field of the cart discount.
 */
export const getVolumeDiscountMinimalQuantity = (
  discount: Maybe<CartDiscountFieldsSource>,
): Maybe<number> => {

  const quantityMin = getDiscountCustomField(discount, DISCOUNT_FIELDS.QUANTITY_MIN);

  if (!quantityMin) {

    return null;

  }

  return Number.parseInt(String(quantityMin), 10) || null;

};
